import { render } from "./HistRegistroConsulta.vue?vue&type=template&id=3a5e145e&scoped=true"
import script from "./HistRegistroConsulta.vue?vue&type=script&lang=js"
export * from "./HistRegistroConsulta.vue?vue&type=script&lang=js"

import "./HistRegistroConsulta.vue?vue&type=style&index=0&id=3a5e145e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a5e145e"]])

export default __exports__